// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"5813":"6fcbbcf6","7718":"2cf8de52","9182":"a8299352"}[chunkId] + ".chunk.css";
};